// Types
import type { TRadioLabelPosition, TRadioProps, TRadioSize } from './Radio.type';

export const RADIO_SIZES: TRadioSize[] = [ 'sm', 'md', 'lg' ];
export const RADIO_SIZE: { [key in TRadioSize]: key } = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
}

export const RADIO_LABEL_POSITIONS: TRadioLabelPosition[] = ['left', 'right'];
export const RADIO_LABEL_POSITION: { [key in TRadioLabelPosition]: key } = {
  left: 'left',
  right: 'right'
}


export const RADIO_DEFAULT_PROPS: TRadioProps = {
  labelPosition: RADIO_LABEL_POSITION.right,
  size: RADIO_SIZE.md
}
